import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';
import type { SearchType } from '#/modules/search/types/SearchType';

import { getCmsApiDocumentDefaultSearchOrPostSearchType } from './getCmsApiDocumentDefaultSearchOrPostSearchType';

type Args = {
  content: CmsApiDocument;
};

export function getCmsApiDocumentDefaultSearchType({
  content,
}: Args): SearchType {
  const contentDefaultSearchType =
    getCmsApiDocumentDefaultSearchOrPostSearchType({
      content,
    });

  if (contentDefaultSearchType === 'CMS_PAGE') return 'JOB';

  return contentDefaultSearchType || 'JOB';
}
